module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_9005.92ce474c.png";